import { FieldConfig } from '@vendasta/platform-integrations';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IntegrationUtilService {
  // Method to extract IDs from FIELD_CONFIG and its dependents
  getFieldIdsFromConfig(fieldConfig: FieldConfig[] | undefined): string[] {
    return fieldConfig
      ? fieldConfig.flatMap((field) => [
          field.id,
          ...(field.dependents ? this.getFieldIdsFromConfig(field.dependents) : []),
        ])
      : [];
  }

  getFieldConfigAsMap(fieldConfig: FieldConfig[] | undefined): Map<string, FieldConfig> {
    if (!fieldConfig) return new Map();

    return new Map(
      fieldConfig.flatMap((setting) => {
        const entries: [string, FieldConfig][] = [[setting.id, setting]];

        // Process dependents if they exist
        if (setting.dependents) {
          setting.dependents.forEach((dependent) => {
            if (dependent.id) {
              entries.push([dependent.id, setting]);
            }
          });
        }

        return entries;
      }),
    );
  }
}
